export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">漫迷心声</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            来自真实读者的评价，听听漫画爱好者们怎么说迷妹漫画
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-4xl mx-auto">

          <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
            <div className="flex items-center gap-1 mb-3">
              {[1, 2, 3, 4, 5].map((s) => (
                <i key={s} className="ri-star-fill text-secondary-500 text-xs"></i>
              ))}
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              "作为一个日漫死忠粉，迷妹漫画简直是我的救星！免费看最新的日漫新番，更新速度还特别快。下拉式阅读体验太舒服了，晚上窝在被窝里看漫画已经成为每天的固定节目了。"
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                <span className="text-xs font-bold text-primary-600">小</span>
              </div>
              <div>
                <p className="text-xs font-medium text-foreground-800">小樱漫迷</p>
                <p className="text-[10px] text-foreground-400">日漫爱好者 · 使用半年</p>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
            <div className="flex items-center gap-1 mb-3">
              {[1, 2, 3, 4, 5].map((s) => (
                <i key={s} className="ri-star-fill text-secondary-500 text-xs"></i>
              ))}
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              "之前追韩漫要翻墙还收费，自从发现了迷妹漫画，所有想看的韩漫都能免费看。完结作品整理得很清楚，不用追更也能一口气看完，太适合我这种急性子了。"
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                <span className="text-xs font-bold text-accent-600">阿</span>
              </div>
              <div>
                <p className="text-xs font-medium text-foreground-800">阿星不爱等</p>
                <p className="text-[10px] text-foreground-400">韩漫爱好者 · 使用1年</p>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
            <div className="flex items-center gap-1 mb-3">
              {[1, 2, 3, 4, 5].map((s) => (
                <i key={s} className="ri-star-fill text-secondary-500 text-xs"></i>
              ))}
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              "国漫这几年真的越来越好了，迷妹漫画上能找到很多优秀的国产漫画。古风题材画风精美，故事也很有深度。最重要的是完全免费，支持好的平台让更多国漫被看到。"
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                <span className="text-xs font-bold text-secondary-600">墨</span>
              </div>
              <div>
                <p className="text-xs font-medium text-foreground-800">墨染清风</p>
                <p className="text-[10px] text-foreground-400">国漫爱好者 · 使用8个月</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}